import axios from "../../utils/request";

function beianzhifu(params) {
  // 网站备案
  axios.interceptors.request.use(
    function(config) {
      config.headers.Authorization =
        "c3R1ZGVudDoxNjYxOTczNDE1NzoxMjM0NTY6cGhvbmU6MTY0OTc1Mjg0Ng==";
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );
  return axios.post("/api/order/v1/pay", params);
}

function versionsets() {
  // 获取展示版本列表
  return axios.get("/api/app/v1/show/versionsets");
}

function resourcelist(params) {
  // 展示资源列表
  return axios.get("/api/app/v1/show/papers?versionset_id=" + params);
}

function resourcePreview(v) {
  // 展示资源详情
  return axios.get(
    `/api/app/v1/show/preview?identity=${v.identity}&time=${v.time}&message=${
      v.msg
    }&paper_id=${v.id}`
  );
}

function news() {
  // 首页考试咨询
  return axios.get("/api/edu/v1/login/news/list/");
}

function information(params) {
  // 资讯公告
  return axios.get(
    `api/edu/v1/login/information/list?cat=${params.cat}&page=${
      params.page
    }&per_page=${params.num}`
  );
}

function informationDetail(params) {
  // 资讯公告详情
  return axios.get(
    `api/edu/v1/login/information/detail?new_id=${params.id}&num=${params.num}`
  );
}

function login(params) {
  //登录
  return axios.post("/api/edu/v1/teacher/login", params);
}

function loginType() {
  //登录
  return axios.get("/api/edu/v1/login/entrance/list?identity=teacher");
}

function teacherRegister(params) {
  //教师注册
  return axios.post("/api/edu/v1/teacher/register", params);
}

function homeList(class_id, homework_status, type) {
  //作业列表
  return axios.get(
    `/api/homework/v1/check/list/${class_id}/${homework_status}?option=${type}`
  );
}

function classList() {
  //班级列表
  return axios.get("/api/edu/v1/teacher/class/list");
}

function videoList() {
  return axios.get("/api/homework/v1/teacher/video/list");
}

function getSpecialSortList(grade_id) {
  //获取专项训练列表
  return axios.get(`/api/paper/v1/special/sort/list/?grade=${grade_id}`);
}

function homeworkAdd(params) {
  //布置作业
  return axios.post("/api/homework/v1/homework/add", params);
}

function getCategory(cat = null, level = null, grade = null) {
  //布置作业获取栏目
  return axios.get(
    `/api/paper/v1/teacher/category/${cat}/?level=${level}&grade=${grade}`
  );
}

function getUnitList(cat, level, category_id, grade) {
  //布置作业获取单元列表
  return axios.get(
    `/api/paper/v1/unit/t_list/${cat}/?level=${level}&category_id=${category_id}&grade=${grade}`
  );
}

function paperList(url) {
  //布置作业题目列表
  return axios.get(url);
}

function paperInfo(paper_id) {
  //布置作业模块详情
  return axios.get("/api/homework/v1/split/paper/info/" + paper_id);
}

function homeworkEdit(params) {
  //修改作业
  return axios.post("/api/homework/v1/homework/edit", params);
}

function teacherPreview(id) {
  //教师预览
  return axios.get(`/api/paper/v1/teacher/preview/${id}`);
}

function checkList(class_id, homework_status, type) {
  //作业列表
  return axios.get(
    `/api/homework/v1/check/list/${class_id}/${homework_status}?option=${type}`
  );
}

function checkListNew(id, type, option) {
  return axios.get(
    `/api/homework/v1/teacher/package/homework/list?class_id=${id}&type=${type}&option=${option}`
  );
}

function homeworkInfo(homework_id) {
  //单个作业信息
  return axios.get(`/api/homework/v1/homework/info/${homework_id}`);
}

function removeHomework(params) {
  //删除作业
  return axios.post("/api/homework/v1/homework/delete", params);
}

function homeworkEdit(params) {
  //修改作业
  return axios.post("/api/homework/v1/homework/edit", params);
}

function createClass(params) {
  //创建班级
  return axios.post("/api/edu/v1/class/create", params);
}

function classEdit(params) {
  //修改班级信息
  return axios.post("/api/edu/v1/class/edit", params);
}

function homeworkReturn(params) {
  //作业退回重做
  return axios.post("/api/homework/v1/homework/return", params);
}

function studentScore(homework_id, cat) {
  //查看学生作业详情
  if (cat == 8 || cat == 9 || cat == 11) {
    return axios.get(`/api/homework/v1/score/other/list/${homework_id}`);
  } else {
    return axios.get(`/api/homework/v1/score/student/v2_list/${homework_id}`);
  }
}

function scoreDetails(params) {
  //查看分数
  return axios.get("/api/homework/v1/score/detail/" + params);
}

function wrongnote(params) {
  //错题本
  return axios.get(
    `/api/homework/v1/wrongnote/list?revised=${params.revised}&cat=${
      params.cat
    }&page=${params.page}&per_page=${params.per_page}&student_id=${params.id}`
  );
}

function wrongnoteHistory(id) {
  //错题本历史记录
  return axios.get(`/api/homework/v1/wrongnote/history?wrongnote_id=${id}`);
}

function wrongnoteDetail(id) {
  //错题本答案
  return axios.get(`/api/homework/v1/wrongnote/detail?wrongnote_id=${id}`);
}

function commenting(params) {
  //全班作业详情
  return axios.post("/api/homework/v1/homework/commenting", params);
}

function otherCommenting(params) {
  //全班作业详情
  return axios.post("/api/homework/v1/other/commenting", params);
}

function uploadAvatar(user, params) {
  //上传头像
  let url =
    user === "student"
      ? "/api/djc/v1/student/avatar/upload"
      : "/api/edu/v1/teacher/avatar";
  return axios.post(url, params);
}

function getAvatar(user) {
  //获取头像
  let url =
    user === "student"
      ? "/api/edu/v1/student/avatar"
      : "/api/djc/v1/student/avatar/download";
  return axios.get(url);
}

function teacherMassage() {
  //教师信息
  return axios.get("/api/edu/v1/teacher/message/detail");
}

function lookupTeacher(params) {
  //转让班级查询教师
  return axios.post("/api/edu/v1/check/teacher/message", params);
}

function transferClass(params) {
  //转让班级
  return axios.post("/api/edu/v1/class/transfer", params);
}

function studentList(params) {
  // 当前班级学生
  let url = `/api/edu/v1/class/student/list/${params.id}?${params.key}=${
    params.val
  }`;
  if (params.group_id > -1) {
    url += `&group_id=${params.group_id}`;
  }
  return axios.get(url);
}

function removeClass(params) {
  //删除班级
  return axios.post("/api/edu/v1/teacher/class/del", params);
}

function studentEdit(params) {
  // 教师修改学生
  return axios.post("/api/edu/v1/class/student/edit", params);
}

function passwdBatchReset(params) {
  // 教师批量重置学生密码
  return axios.post("/api/edu/v1/passwd/batch/reset", params);
}

function removeStudent(params) {
  //删除学生
  return axios.post("/api/edu/v1/class/student/del", params);
}

function studentPaperList(params) {
  // 学生做题列表
  return axios.post("/api/homework/v1/student/exercise/record", params);
}

function changeTeacherPassword(params) {
  //教师修改密码
  return axios.post("/api/edu/v1/teacher/passwd/edit", params);
}

function forgetPassword(params) {
  //忘记密码
  return axios.post("/api/djc/v1/passwd/forget", params);
}

function getCode(params) {
  //获取验证码
  return axios.post("/api/edu/v1/code/get", params);
}

function salesLogin(params) {
  //代理商登录
  return axios.post("/api/djc/v1/agent/login", params);
}

function salesSchool() {
  //代理商学校列表
  return axios.get("/api/djc/v1/agent/detail");
}

function salesDetail(url) {
  //代理商详情
  return axios.get(url);
}

function logList(url) {
  //日志列表
  return axios.get(url);
}

function logDetail(url) {
  //日志详情
  return axios.get(url);
}

function getProvince(params) {
  // 获取省
  return axios.get("/api/djc/v1/province/list/" + params);
}

function getCity(params) {
  // 获取市
  return axios.get("/api/djc/v1/city/list/" + params);
}

function getArea(params) {
  // 获取区
  return axios.get("/api/djc/v1/area/list/" + params);
}

function getSchool(id, level) {
  // 获取学校
  let url = `/api/djc/v1/school/list/${id}`;
  if (level) {
    url += `?level=${level}`;
  }
  return axios.get(url);
}

function download(params) {
  // PC端下载
  return axios.get("/api/app/v1/version/detail/" + params);
}

function feedback(params) {
  //用户反馈
  return axios.post("/api/edu/v1/teacher/feedback/create", params);
}

function symbolsDo(params) {
  // 音标做题
  return axios.get(
    `/api/homework/v1/symbol/do?symbol_id=${params.symbol_id}&homework_id=${
      params.homework_id
    }&choice=${params.choice}&student_id=${params.student_id}`
  );
}

function followDo(params) {
  // 课文跟读练习
  return axios.post("/api/homework/v1/follow/do", params);
}

function classStatusChange(params) {
  // 修改班级状态（是否加锁，是否结业）
  return axios.post("/api/edu/v1/class/status/change", params);
}

function ECOlogin(params) {
  // 天闻ECO云开发平台单点登录
  return axios.post("/api/edu/v1/ECO/login", params);
}

function createGroup(params) {
  // 创建分组
  return axios.post("/api/edu/v1/group/add", params);
}

function groupEdit(params) {
  // 修改分组
  return axios.post("/api/edu/v1/group/edit", params);
}

function groupDelete(params) {
  // 删除分组
  return axios.post("/api/edu/v1/group/delete", params);
}

function groupList(params) {
  // 分组列表
  return axios.get("/api/edu/v1/class/group/list?class_id=" + params);
}

function editGroupName(params) {
  // 编辑分组名称
  return axios.post("/api/edu/v1/group/edit", params);
}

function editGroupStudent(params) {
  // 编辑分组学生
  return axios.post("/api/edu/v1/group/student/edit", params);
}

function homeworkHistory(params) {
  // 布置历史
  return axios.get("/api/homework/v1/homework/history?paper_id=" + params);
}

function getLevel() {
  return axios.get("/api/edu/v1/teacher/level");
}

function getPll(params) {
  return axios.get(`/api/app/v1/get/plug-ins?type=${params}`);
}

function PPT(params) {
  return axios({
    url: "/api/edu/v1/ppt/list",
    method: "GET",
    params
  });
}

function getClassroomRandom() {
  return axios.get("/api/app/v1/classroom/random/detail");
}

function recordTeacherHomeworkHistory(params) {
  // 记录教师布置作业当前位置
  return axios.post("/api/edu/v1/record/teacher/homework/history", params);
}

function getTeacherHomeworkHistory(params) {
  // 获取教师布置作业位置
  return axios.get(`/api/edu/v1/get/teacher/homework/history?cat=${params}`);
}

function getInfoTags() {
  // 获取资源库分类
  return axios.get(`/api/paper/v1/info/tags`);
}

function qiniuToken(name, msg, time) {
  // 获取七牛token
  return axios.get(
    `/api/app/v1/qiniu/token?file_name=${name}&message=${msg}&time=${time}`
  );
}

function infoAdd(params) {
  // info新增
  return axios.post(`/api/paper/v1/info/add`, params);
}

function infoSearch(params) {
  // info搜索
  return axios.post(`/api/paper/v1/info/search`, params);
}

function infoUpdate(params) {
  // info更新
  return axios.post(`/api/paper/v1/info/update`, params);
}

function deletePackage(params) {
  // 删除作业包
  return axios.post(`/api/homework/v1/teacher/package/delete`, params);
}

function editPackage(params) {
  // 修改作业包
  return axios.post(`/api/homework/v1/teacher/package/edit`, params);
}

function homeworkNotice(params) {
  // 作业通知
  return axios.post(`/api/homework/v1/homework/notice`, params);
}

function getStatistic(params) {
  // 获取统计
  return axios.post(`/api/homework/v1/scoreanswer/detail`, params);
}

function tagCode(params) {
  // 获取标签码
  return axios.post(`/api/app/v1/tag/code`, params);
}

export default {
  beianzhifu,
  information,
  informationDetail,
  news,
  login,
  teacherRegister,
  homeList,
  classList,
  getSpecialSortList,
  wrongnote,
  wrongnoteHistory,
  wrongnoteDetail,
  homeworkAdd,
  getCategory,
  getUnitList,
  paperList,
  paperInfo,
  homeworkEdit,
  teacherPreview,
  checkList,
  checkListNew,
  homeworkInfo,
  passwdBatchReset,
  videoList,
  removeHomework,
  createClass,
  classEdit,
  homeworkReturn,
  studentScore,
  scoreDetails,
  commenting,
  uploadAvatar,
  getAvatar,
  teacherMassage,
  lookupTeacher,
  transferClass,
  studentList,
  removeClass,
  studentEdit,
  removeStudent,
  studentPaperList,
  changeTeacherPassword,
  forgetPassword,
  getCode,
  salesLogin,
  salesSchool,
  salesDetail,
  logList,
  logDetail,
  getProvince,
  getCity,
  getArea,
  getSchool,
  download,
  feedback,
  symbolsDo,
  followDo,
  otherCommenting,
  classStatusChange,
  loginType,
  ECOlogin,
  createGroup,
  groupEdit,
  groupDelete,
  groupList,
  editGroupName,
  editGroupStudent,
  homeworkHistory,
  getLevel,
  getPll,
  versionsets,
  resourcelist,
  resourcePreview,
  PPT,
  getClassroomRandom,
  recordTeacherHomeworkHistory,
  getTeacherHomeworkHistory,
  getInfoTags,
  qiniuToken,
  infoAdd,
  infoSearch,
  infoUpdate,
  deletePackage,
  editPackage,
  homeworkNotice,
  getStatistic,
  tagCode
};



// WEBPACK FOOTER //
// ./src/components/api/index.js